const TERMINAL_STATUSES = ['closed', 'expired'];

// Quem atende agora: o colaborador atual (assignedToName); se o lead está
// encerrado/expirado sem atendimento ativo, mostra quem atendeu por último
// (histórico); caso contrário (aberto/em andamento sem atribuição atual —
// por exemplo, acabou de ser liberado) é a IA que está atendendo de novo.
// `lastAssignedToName` NÃO é limpo no release, então não pode ser o fallback
// para status ativos — senão o lead "volta pra IA" mas a UI continua
// mostrando o último vendedor.
export const getServedByName = ({ assignedToName, lastAssignedToName, status }) => {
  if (assignedToName) return assignedToName;
  if (TERMINAL_STATUSES.includes(status)) return lastAssignedToName || '';
  return '';
};
